
function repositionArticleImgs() {
    const articleImgs = document.querySelectorAll('.list-card-img img');
    articleImgs.forEach(imgElem => {
        if(imgElem.getAttribute('height') < 300) {
            imgElem.classList.add('vertical-align');
        }
    });
}

export default function init() {
    repositionArticleImgs();
}